import { useEffect, useState } from 'react';
import api from '../lib/api';
import { Search as SearchIcon, UserPlus, Check } from 'lucide-react';
import { toast } from 'sonner';
import ExplorerAvatar from '../components/ExplorerAvatar';

export default function Friends() {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [data, setData] = useState({ friends: [], pending_in: [], pending_out: [] });

  const refresh = () => api.get('/friends').then(r => setData(r.data)).catch(() => {});
  useEffect(refresh, []);
  useEffect(() => {
    if (q.length < 2) { setResults([]); return; }
    const t = setTimeout(() => api.get('/users/search', { params: { q } }).then(r => setResults(r.data)).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]);

  const sendRequest = async (uid) => {
    try { await api.post('/friends/request', { user_id: uid }); toast.success('Request sent'); refresh(); }
    catch { toast.error('Failed'); }
  };
  const accept = async (fid) => {
    try { await api.post('/friends/accept', { friendship_id: fid }); toast.success('Friend added'); refresh(); }
    catch { toast.error('Failed'); }
  };

  return (
    <div className="space-y-5" data-testid="friends-root">
      <h2 className="font-serif text-3xl">Friends</h2>

      <div className="flex items-center gap-2 rounded-full bg-card border border-white/5 px-4 py-3">
        <SearchIcon className="w-4 h-4 text-muted-foreground" />
        <input data-testid="friends-search" value={q} onChange={e => setQ(e.target.value)} placeholder="Search explorers…" className="bg-transparent outline-none flex-1 text-sm placeholder:text-muted-foreground" />
      </div>

      {results.length > 0 && (
        <section>
          <h3 className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">Search Results</h3>
          <div className="space-y-2">
            {results.map(u => (
              <div key={u.user_id} className="rounded-2xl bg-card border border-white/5 p-3 flex items-center gap-3">
                <ExplorerAvatar src={u.picture} name={u.name} founder={!!u.is_founder} size="w-10 h-10" />
                <div className="flex-1 min-w-0"><p className="text-sm truncate">{u.name}</p><p className="text-[10px] font-mono text-muted-foreground">{u.xp || 0} XP · {u.species_count || 0} species</p></div>
                <button data-testid={`add-${u.user_id}`} onClick={() => sendRequest(u.user_id)} className="p-2 rounded-full bg-primary hover:bg-primary-light"><UserPlus className="w-4 h-4" /></button>
              </div>
            ))}
          </div>
        </section>
      )}

      {data.pending_in.length > 0 && (
        <section>
          <h3 className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">Pending Requests</h3>
          <div className="space-y-2">
            {data.pending_in.map(p => (
              <div key={p.friendship_id} className="rounded-2xl bg-card border border-accent/40 p-3 flex items-center gap-3">
                <ExplorerAvatar src={p.user?.picture} name={p.user?.name} founder={!!p.user?.is_founder} size="w-10 h-10" />
                <p className="flex-1 text-sm">{p.user?.name || 'Explorer'}</p>
                <button data-testid={`accept-${p.friendship_id}`} onClick={() => accept(p.friendship_id)} className="px-3 py-1.5 rounded-full bg-accent text-black text-xs font-medium flex items-center gap-1"><Check className="w-3 h-3" /> Accept</button>
              </div>
            ))}
          </div>
        </section>
      )}

      <section>
        <h3 className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">Your Friends ({data.friends.length})</h3>
        {data.friends.length === 0 ? (
          <div className="rounded-3xl bg-card border border-white/5 p-8 text-center text-sm text-muted-foreground">Search for explorers to add them as friends.</div>
        ) : (
          <div className="space-y-2">
            {data.friends.map(u => (
              <div key={u.user_id} className="rounded-2xl bg-card border border-white/5 p-3 flex items-center gap-3">
                <ExplorerAvatar src={u.picture} name={u.name} founder={!!u.is_founder} size="w-10 h-10" />
                <div className="flex-1 min-w-0"><p className="text-sm truncate">{u.name}</p><p className="text-[10px] font-mono text-muted-foreground">{u.xp || 0} XP · {u.species_count || 0} species</p></div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
